import { Database, Calculator, Search } from 'lucide-react'
import { cn } from '@/lib/utils'

interface ChatEmptyStateProps {
  className?: string
}

const capabilities = [
  {
    icon: Search,
    title: 'Search Ecoinvent',
    description: 'Find activities, processes, and emissions',
  },
  {
    icon: Calculator,
    title: 'Calculate Impacts',
    description: 'Run LCA calculations with various methods',
  },
  {
    icon: Database,
    title: 'Explore Data',
    description: 'Browse databases and method categories',
  },
]

export function ChatEmptyState({ className }: ChatEmptyStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center min-h-[60vh] px-4', className)}>
      <div className="text-center space-y-6 max-w-lg">
        {/* Logo/Icon */}
        <div className="flex justify-center">
          <div className="relative">
            <div className="w-12 h-12 rounded-xl bg-background shadow-sm border border-border/40 flex items-center justify-center overflow-hidden">
              <img src="/logo-square.svg" alt="EcoSemantic" className="w-8 h-8 object-contain" />
            </div>
            <div className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full bg-success/20 flex items-center justify-center">
              <div className="w-1.5 h-1.5 rounded-full bg-success animate-pulse" />
            </div>
          </div>
        </div>

        {/* Welcome Text */}
        <div className="space-y-2">
          <h2 className="text-2xl font-semibold tracking-tight">How can I help you today?</h2>
          <p className="text-muted-foreground text-sm">
            Ask me about environmental impact analysis, LCA calculations, or explore the Ecoinvent
            database.
          </p>
        </div>

        {/* Capabilities */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 pt-4">
          {capabilities.map((cap) => (
            <div
              key={cap.title}
              className="flex flex-col items-center gap-2 p-4 rounded-lg border border-border/50 bg-muted/30 hover:bg-muted/50 transition-colors"
            >
              <cap.icon className="w-5 h-5 text-muted-foreground" />
              <div className="text-center">
                <p className="text-sm font-medium">{cap.title}</p>
                <p className="text-xs text-muted-foreground">{cap.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}
